import z from 'zod'

export const updateCameraFormSchema = z.object({
  cameraTypeId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  active: z.enum(['true', 'false']),
})
